import React from "react";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import BusinessImpactSection from "./layout/BusinessImpactSection";
import CapabilityCardsSection from "./layout/CapabilityCardsSection";

const banner = {
  background: "banner/supply-chain.png",
  Title: "OUR BUSINESS",
  childTitle: "COMMODITY &<br/>SUPPLY CHAIN",
  desktopCol: "8"
}

const coreCapabilities = [
  {
    number: "01",
    title: "ENERGY & OILFIELD COMMODITIES",
    image: "content/supply-chain1.png",
    items: [
      "Crude Oil and Refined Petroleum Products",
      "EN590, D2 Diesel, Jet A-1 and Aviation Fuels",
      "Natural Gas, LNG and Industrial Gases",
      "Drilling, Production and Oilfield Chemicals"
    ]
  },
  {
    number: "02",
    title: "ADVANCED TECHNOLOGY & CABLE MATERIALS",
    image: "content/supply-chain2.png",
    items: [
      "Optical Fiber and Fiber-Optic Cable",
      "Ultra-High-Purity Preform Materials - GeCl₄",
      "Liquid Helium and Advanced Process Chemicals",
      "Power, Data Center and Telecommunications Cables"
    ]
  },
  {
    number: "03",
    title: "INDUSTRIAL METALS & CIRCULAR ECONOMY",
    image: "content/supply-chain3.png",
    items: [
      "Copper, Gold, Aluminium, Steel, Nickel and Iron Ore",
      "Recycled Metals, Copper Scrap, Steel Scrap",
      "Responsible Recovery, Processing and Resource Optimization",
      "Closed-Loop Supply and Circular Economy Solutions"
    ]
  },
  {
    number: "04",
    title: "SPECIALTY ALLOYS MATERIALS",
    image: "content/supply-chain4.png",
    items: [
      "Tungsten, Tungsten Carbide and Heavy Alloys",
      "Titanium, Molybdenum and High-Performance Metals",
      "Rare Metals, Rare-Earth Oxides and Strategic Minerals",
      "Antimony and Specialty Aerospace & Defense Grade Alloys"
    ]
  }
];

const impactSection = {
  titleLines: [
    "POWERING INFRASTRUCTURE,",
    "ENERGY, AND ADVANCED",
    "TECHNOLOGY"
  ],
  paragraphs: [
    "HMG's commodity trading & supply chain division connects strategic raw materials, industrial commodities, and advanced technology inputs with the infrastructure, energy, and manufacturing sectors that depend on them.",
    "Through our global sourcing network and regional market access, we support reliable procurement, allocation, and distribution of critical materials across Asia and international markets. Our role is to bridge upstream supply with downstream industrial demand - powering infrastructure projects, next-generation technology platforms, and industrial growth."
  ],
  image: "content/supply-chain-impact.png",
  imageAlt: "Global commodity supply chain collage"
};

class CommoditySupplyChain extends React.Component {
  render() {
    return (
      <>
        <DemoNavbar />
        <main className="food commodity-supply-chain-page commodity-supply-chain-materials-page" ref="main">
          <ChildPageBanner banner={banner} />
          <BusinessImpactSection {...impactSection} />
          <CapabilityCardsSection
            heading="CORE CAPABILITIES"
            capabilities={coreCapabilities}
          />
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default CommoditySupplyChain;
